import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import "./Form.css";

const { Item: ItemForm } = Form;

export default class CtaCorrenteForm extends Component {
  state = {
    registro: {
      cc_codigo: '',
      cc_descricao: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {
        this.refs.cc_codigo.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.cc_descricao) || (this.state.registro.cc_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { cc_idf, cc_codigo, cc_descricao } = this.state.registro;

    return (
      <Modal
        title={cc_idf ? "Edição de Conta Corrente" : "Cadastro de Conta Corrente"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Código</span>
              <InputForm
                id="cc_codigo"
                ref="cc_codigo"
                onChange={this.onChange}
                value={cc_codigo}
                validator={value => Boolean(value)}
                disabled={true}
              />
            </Col>

            <Col xs={24} sm={20}>
              <span>Descrição *</span>
              <InputForm
                id="cc_descricao"
                ref="cc_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={cc_descricao}
                validator={value => Boolean(value)}
              />
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CtaCorrenteForm.js